__turbopack_context__.v({
  "action": "header-module-scss-module__PCizCa__action",
  "header": "header-module-scss-module__PCizCa__header",
  "headerTextContainer": "header-module-scss-module__PCizCa__headerTextContainer",
  "hidden": "header-module-scss-module__PCizCa__hidden",
  "loading": "header-module-scss-module__PCizCa__loading",
});
